import { AdvertisementService } from './advertisement.service';
import { AiAssistantService } from './aiAssistant.service';
import { AiChatService } from './aiChat.service';
import { AiChatQuestionnaireService } from './aiChatQuestionnaire.service';
import { AiChatSuggestionService } from './aiChatSuggestion.service';
import { AuthService } from './auth.service';
import { ClassNotifyService } from './classNotify.service';
import { ConsultService } from './consult.service';
import { CourseMenuService } from './courseMenu.service';
import { CourseThemeService } from './courseTheme.service';
import { DonationService } from './donation.service';
import { EventCardService } from './eventCard.service';
import { FunCoinService } from './funCoin.service';
import { FunctionService } from './function';
import { FunctionV2Service } from './function.service';
import { FunTvService } from './funTv.service';
import { KVService } from './kv.service';
import { LearningProgressService } from './learningProgress.service';
import { LessonSuggestService } from './lessonSuggest.service';
import { ListeningService } from './listening.service';
import { LiveStreamService } from './liveStream.service';
import { LoginService } from './login.service';
import { MemberService } from './member.service';
import { MemberExperienceService } from './memberExperience.service';
import { MemberPlanService } from './memberPlan.service';
import { MemberRecordService } from './memberRecord.service';
import { MemberV2Service } from './memberV2.service';
import { MutipleMediaService } from './mutipleMedia.service copy';
import { NewCourseService } from './newCourse';
import { NewCourseV2Service } from './newCourseV2.service';
import { NewHomeworkService } from './newHomework.service';
import { NewProductService } from './newProduct';
import { PayService } from './pay.service';
import { ReadingService } from './reading.service';
import { ReviewService } from './review.service';
import { ScheduleService } from './schedule.service';
import { SocialService } from './social.service';
import { SocialLogService } from './socialLog.service';
import { TelemarketQuestionnaireService } from './telemarketQuestionnare.service';
import { TestService } from './test.service';
import { TodayService } from './today.service';
import { ToeicService } from './toeic.service';
import { TutorService } from './tutor.service';
import { TutorClassService } from './tutorClass.service';
import { userActiveLogService } from './userActiveLog.service';
import { userReportsService } from './userReports.service';
import { VideoLibraryService } from './videoLibrary.service';

const api = {
  test: new TestService(),
  review: new ReviewService(),
  login: new LoginService(),
  kv: new KVService(),
  lessonSuggest: new LessonSuggestService(),
  videoLibrary: new VideoLibraryService(),
  teacher: new TeacherService(),
  toeic: new ToeicService(),
  telemarketQuestionnaire: new TelemarketQuestionnaireService(),
  aiAssistant: new AiAssistantService(),
  tutorClass: new TutorClassService(),
  schedule: new ScheduleService(),
  member: new MemberService(),
  memberV2: new MemberV2Service(),
  memberPlan: new MemberPlanService(),
  userReports: new userReportsService(),
  today: new TodayService(),
  listening: new ListeningService(),
  reading: new ReadingService(),
  social: new SocialService(),
  socialLog: new SocialLogService(),
  eventCard: new EventCardService(),
  funTv: new FunTvService(),
  mutipleMedia: new MutipleMediaService(),
  memberRecord: new MemberRecordService(),
  funCoin: new FunCoinService(),
  newProduct: new NewProductService(),
  function: new FunctionService(),
  pay: new PayService(),
  donation: new DonationService(),
  newCourse: new NewCourseService(),
  newCourseV2: new NewCourseV2Service(),
  auth: new AuthService(),
  liveStream: new LiveStreamService(),
  consult: new ConsultService(),
  learningProgress: new LearningProgressService(),
  aiChat: new AiChatService(),
  aiChatQuestionnaire: new AiChatQuestionnaireService(),
  aiChatSuggestion: new AiChatSuggestionService(),
  tutor: new TutorService(),
  userActiveLog: new userActiveLogService(),
  courseTheme: new CourseThemeService(),
  courseMenu: new CourseMenuService(),
  advertisement: new AdvertisementService(),
  classNotify: new ClassNotifyService(),
  newHomework: new NewHomeworkService(),
  memberExperience: new MemberExperienceService(),
  functionV2: new FunctionV2Service()
};

export { api };
